import { Col, Input, Drawer, Row, Tabs } from 'antd';
const { TextArea } = Input;
import AnimatedTextField from "components/AnimatedTextField";
import { Heading } from 'components/Typography';
import React, { useEffect, useState } from 'react';
import { Button } from 'components/Button';
import { connect } from 'react-redux';
// import CustomDatePicker from "components/CustomDatePicker";
import moment from 'moment';
import { calculateLeaveDays, requestLeaveOrAttendance } from 'actions/userManagementV3';
import "./tabsStyles.css";
import { CloseOutlined } from '@ant-design/icons';
import AnimatedCustomSelect from 'components/AnimatedSelectComp';
import AnimatedDatePicker from 'components/AnimatedDatePicker';
import ConfirmLeaveEdit from './confirmLeaveEdit';
const { TabPane } = Tabs;

const hasLeavePrivilege = (u) => {
    const p = u?.privilage || u?.privilege || u?.privilages;
    if (Array.isArray(p)) {
        return p.some(val => ['superadmin', 'leavemanager'].includes(String(val).toLowerCase()));
    }
    if (typeof p === 'string') {
        const lower = p.toLowerCase();
        return lower.includes('superadmin') || lower.includes('leavemanager');
    }
    return false;
};

const MarkLeaveDrawer = ({ onClose, visible, leaveDetails_V3, leaveTypes, requestLeaveOrAttendance, leaveFormDetails,
    setLeaveDetails, calculateLeaveDays, user, setPageLoader, userRowDetails, fromWhere, isEdit, setIsEdit, specificUserProfile, specificUserId }) => {

    const [allowSelectEndDate, setAllowSelectEndDate] = useState(true);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [activeTab, setActiveTab] = useState('general');

    const targetUserId = specificUserProfile?.id || specificUserId || userRowDetails?.id || user?.id;

    const clearDates = () => {
        setLeaveDetails((prevState) => ({ ...prevState, startDate: null, endDate: null, duration: '', reason: '', leaveType: null, subType: null }));
    };
    useEffect(() => {
        if (activeTab === 'special') {
            clearDates();
            setAllowSelectEndDate(true);
        } else {
            setAllowSelectEndDate(true);
            clearDates(); // Clear dates and other relevant data for 'general' tab
        }
    }, [activeTab]);


    useEffect(() => {
        if (leaveFormDetails?.subType === 'half-day') {
            setAllowSelectEndDate(false);
            if (leaveFormDetails?.startDate) {
                setLeaveDetails((prevState) => ({
                    ...prevState,
                    endDate: leaveFormDetails?.startDate,
                }));
            }
        } else {
            setAllowSelectEndDate(true);
            // clearDates();
        }
    }, [leaveFormDetails?.subType]);
    useEffect(() => {
        if (leaveFormDetails?.subType === "half-day") {
            if (leaveFormDetails?.startDate && leaveFormDetails?.endDate !== leaveFormDetails?.startDate) {
                setLeaveDetails((prev) => ({
                    ...prev,
                    endDate: prev?.startDate || null
                }));
            }
        }
    }, [leaveFormDetails?.startDate, leaveFormDetails?.subType]);
    useEffect(() => {
        if (leaveFormDetails?.startDate && leaveFormDetails?.endDate) {
            const params = {
                halfDay: leaveFormDetails?.subType === 'half-day',
                startDate: moment(leaveFormDetails?.startDate).format("YYYY-MM-DD"),
                endDate: moment(leaveFormDetails?.endDate).format("YYYY-MM-DD"),
                userId: targetUserId
            };
            calculateLeaveDays(params, data => {
                let calculatedDays = '';
                if (typeof data === 'number' || typeof data === 'string') {
                    calculatedDays = data;
                } else if (Array.isArray(data)) {
                    calculatedDays = data.length;
                } else if (data && typeof data === 'object') {
                    calculatedDays = data?.size ?? data?.days ?? data?.duration ?? data?.count ?? data?.noOfDays ?? (Array.isArray(data?.data) ? data.data.length : data?.data);
                }
                setLeaveDetails(prev => ({
                    ...prev,
                    duration: (calculatedDays !== undefined && calculatedDays !== null) ? calculatedDays : ''
                }));
            });
        }
    }, [leaveFormDetails?.startDate, leaveFormDetails?.endDate, leaveFormDetails?.subType]);

    const handleSave = () => {
        const params = {
            ...leaveFormDetails,
            requestType: "Leave",
            startDate: moment(leaveFormDetails?.startDate).format("YYYY-MM-DD"),
            endDate: moment(leaveFormDetails?.endDate).format("YYYY-MM-DD"),
            noOfdays: leaveFormDetails?.duration,
            userId: targetUserId
        };
        setButtonLoader(true);
        requestLeaveOrAttendance(params, () => {
            setButtonLoader(false);
            setConfirmVisible(false);
            setIsEdit(false);
        }, () => {
            setButtonLoader(false);
            setConfirmVisible(false);
            if (typeof onClose === 'function') {
                onClose(true);
            }
        }, setPageLoader);
    };

    const getSelectedUserLeave = (leaveTypeName = leaveFormDetails?.leaveType) => {
        const userLeavesList = leaveDetails_V3?.leaveTypesForUser || leaveDetails_V3?.data?.leaveTypesForUser || leaveTypes?.leaveTypesForUser || [];
        return userLeavesList?.find(
            item => String(item?.leaveType || '').trim().toLowerCase() === String(leaveTypeName || '').trim().toLowerCase()
        );
    };

    const getLeaveBackDays = (leaveObj) => {
        if (!leaveObj) return 0;
        const raw = leaveObj?.backDays ?? leaveObj?.totalBackDays ?? leaveObj?.backDateDays;
        if (typeof raw === 'number' && !isNaN(raw)) {
            return Math.max(0, raw);
        }
        if (typeof raw === 'string' && raw.trim() !== '' && !isNaN(Number(raw))) {
            return Math.max(0, Number(raw));
        }
        if (leaveObj?.totalBackDays && !isNaN(Number(leaveObj.totalBackDays))) {
            return Math.max(0, Number(leaveObj.totalBackDays));
        }
        return 0;
    };

    const disabledStartDate = (current) => {
        if (!current) return false;
        const selectedUserLeaveType = getSelectedUserLeave();
        const leaveStartDate = selectedUserLeaveType?.startDate && moment(selectedUserLeaveType.startDate).isValid()
            ? moment(selectedUserLeaveType.startDate).startOf('day')
            : null;
        const leaveEndDate = selectedUserLeaveType?.endDate && moment(selectedUserLeaveType.endDate).isValid()
            ? moment(selectedUserLeaveType.endDate).endOf('day')
            : null;

        const backDays = getLeaveBackDays(selectedUserLeaveType);
        const minAllowedDate = moment().subtract(backDays, 'days').startOf('day');

        if (current.isBefore(minAllowedDate, 'day')) {
            return true;
        }
        if (leaveStartDate && current.isBefore(leaveStartDate, 'day')) {
            return true;
        }
        if (leaveEndDate && current.isAfter(leaveEndDate, 'day')) {
            return true;
        }
        return false;
    };

    const disabledEndDate = (current) => {
        if (!current) return false;
        const selectedUserLeaveType = getSelectedUserLeave();
        const leaveStartDate = selectedUserLeaveType?.startDate && moment(selectedUserLeaveType.startDate).isValid()
            ? moment(selectedUserLeaveType.startDate).startOf('day')
            : null;
        const leaveEndDate = selectedUserLeaveType?.endDate && moment(selectedUserLeaveType.endDate).isValid()
            ? moment(selectedUserLeaveType.endDate).endOf('day')
            : null;

        // End date should be selectable from the selected startDate onwards
        if (leaveFormDetails?.startDate) {
            const start = moment(leaveFormDetails.startDate).startOf('day');
            if (start.isValid() && current.isBefore(start, 'day')) {
                return true;
            }
        } else {
            return true;
        }

        if (leaveStartDate && current.isBefore(leaveStartDate, 'day')) {
            return true;
        }
        if (leaveEndDate && current.isAfter(leaveEndDate, 'day')) {
            return true;
        }

        return false;
    };

    const generalLeaveTypes = ['Privilege', 'Sick', 'Casual', 'Earned'];
    const userLeavesList = leaveDetails_V3?.leaveTypesForUser || leaveDetails_V3?.data?.leaveTypesForUser || [];
    const generalLeaves = userLeavesList?.filter(leave =>
        generalLeaveTypes.some(g => g.toLowerCase() === String(leave?.leaveType || '').trim().toLowerCase())
    );
    const specialLeaves = userLeavesList?.filter(leave =>
        !generalLeaveTypes.some(g => g.toLowerCase() === String(leave?.leaveType || '').trim().toLowerCase())
    );

    const getLeaveSubTypePermissions = (leaveObj) => {
        if (!leaveObj) return { isFullDayAllowed: false, isHalfDayAllowed: false };

        if (Array.isArray(leaveObj?.allowedSubTypes) || Array.isArray(leaveObj?.applicableSubTypes) || Array.isArray(leaveObj?.subTypes)) {
            const subTypesList = (leaveObj.allowedSubTypes || leaveObj.applicableSubTypes || leaveObj.subTypes).map(s => String(s).toLowerCase().replace(/[\s_]/g, '-'));
            const isFull = subTypesList.includes('full-day') || subTypesList.includes('fullday');
            const isHalf = subTypesList.includes('half-day') || subTypesList.includes('halfday');
            return { isFullDayAllowed: isFull, isHalfDayAllowed: isHalf };
        }

        const halfDayFlag = leaveObj.halfDayApplicable ?? leaveObj.halfDay ?? leaveObj.isHalfDay ?? leaveObj.allowHalfDay;
        const fullDayFlag = leaveObj.fullDayApplicable ?? leaveObj.fullDay ?? leaveObj.isFullDay ?? leaveObj.allowFullDay;

        const isHalfDayOnly = Boolean(leaveObj.halfDayOnly || leaveObj.isHalfDayOnly || leaveObj.onlyHalfDay);
        const isFullDayOnly = Boolean(leaveObj.fullDayOnly || leaveObj.isFullDayOnly || leaveObj.onlyFullDay);

        const isHalf = !isFullDayOnly && Boolean(halfDayFlag);
        const isFull = !isHalfDayOnly && (fullDayFlag !== false);

        return { isFullDayAllowed: isFull, isHalfDayAllowed: isHalf };
    };

    const selectedGeneralLeave = generalLeaves?.find(leave =>
        String(leave?.leaveType || '').trim().toLowerCase() === String(leaveFormDetails?.leaveType || '').trim().toLowerCase()
    );
    const { isFullDayAllowed, isHalfDayAllowed } = leaveFormDetails?.leaveType
        ? getLeaveSubTypePermissions(selectedGeneralLeave)
        : { isFullDayAllowed: false, isHalfDayAllowed: false };

    const handleButtonClick = (subType) => {
        if (subType === "full-day" && !isFullDayAllowed) return;
        if (subType === "half-day" && !isHalfDayAllowed) return;
        setLeaveDetails({ ...leaveFormDetails, subType });
    };

    const isMark = hasLeavePrivilege(user);

    return (
        <>
            <Drawer
                title={isEdit ? (isMark ? 'Edit mark leaves' : 'Edit apply leaves') : (isMark ? 'Mark leaves' : 'Apply leaves')}
                placement="right"
                closable={true}
                onClose={() => {
                    setConfirmVisible(false);
                    onClose(false);
                }}
                visible={visible}
            closeIcon={<CloseOutlined style={{ position: 'absolute', top: '16px', right: '16px', fontSize: '16px', }} onClick={() => onClose(false)} />}
            headerStyle={{ borderBottom: 'none' }}
            width={'35%'}
        >
            <Tabs style={{ width: '100%' }} tabBarStyle={{ display: 'flex', width: '100%' }} moreIcon={null}
                className="mark-attendance-tabs" activeKey={activeTab} onChange={setActiveTab}>
                <TabPane tab={<div style={{ flex: 1, textAlign: 'center' }}>General Leaves</div>}
                    key="general">
                    <div className='p-l-20 p-r-20' style={{ paddingTop: 0 }}>
                        <AnimatedCustomSelect
                            keepOpenOnClick={true}
                            label={"Leave type"}
                            required={true}
                            options={generalLeaves?.map(leave => ({
                                label: leave.leaveType,
                                value: leave.leaveType
                            }))}
                            handleSelectChange={(value) => {
                                const selectedLeave = generalLeaves?.find(leave => leave.leaveType === value);
                                const { isFullDayAllowed: allowFull, isHalfDayAllowed: allowHalf } = getLeaveSubTypePermissions(selectedLeave);

                                let nextSubType = leaveFormDetails?.subType;
                                if (nextSubType === 'full-day' && !allowFull) {
                                    nextSubType = allowHalf ? 'half-day' : null;
                                } else if (nextSubType === 'half-day' && !allowHalf) {
                                    nextSubType = allowFull ? 'full-day' : null;
                                } else if (!nextSubType) {
                                    if (allowFull && !allowHalf) {
                                        nextSubType = 'full-day';
                                    } else if (!allowFull && allowHalf) {
                                        nextSubType = 'half-day';
                                    }
                                }

                                const selectedUserLeave = getSelectedUserLeave(selectedLeave?.leaveType);
                                const leaveStart = selectedUserLeave?.startDate && moment(selectedUserLeave.startDate).isValid()
                                    ? moment(selectedUserLeave.startDate).startOf('day')
                                    : null;
                                const leaveEnd = selectedUserLeave?.endDate && moment(selectedUserLeave.endDate).isValid()
                                    ? moment(selectedUserLeave.endDate).endOf('day')
                                    : null;
                                const bDays = getLeaveBackDays(selectedUserLeave);
                                const minStart = moment().subtract(bDays, 'days').startOf('day');

                                let nextStartDate = leaveFormDetails?.startDate;
                                let nextEndDate = leaveFormDetails?.endDate;
                                let nextDuration = leaveFormDetails?.duration;

                                if (nextStartDate) {
                                    const s = moment(nextStartDate).startOf('day');
                                    if (s.isBefore(minStart, 'day') || (leaveStart && s.isBefore(leaveStart, 'day')) || (leaveEnd && s.isAfter(leaveEnd, 'day'))) {
                                        nextStartDate = null;
                                        nextEndDate = null;
                                        nextDuration = '';
                                    }
                                }
                                if (nextEndDate && leaveEnd && moment(nextEndDate).isAfter(leaveEnd, 'day')) {
                                    nextEndDate = null;
                                    nextDuration = '';
                                }

                                setLeaveDetails({
                                    ...leaveFormDetails,
                                    leaveType: selectedLeave?.leaveType,
                                    subType: nextSubType,
                                    startDate: nextStartDate,
                                    endDate: nextEndDate,
                                    duration: nextDuration
                                });
                            }}
                            value={leaveFormDetails?.leaveType}
                            isSelected={leaveFormDetails?.leaveType ? true : false}
                        />
                    </div>
                    <div className='p-20' style={{ paddingTop: 0 }}>
                        <div style={{ color: '#888', fontSize: '14px', fontWeight: '400' }}>Sub type<span style={{ color: 'red' }}> *</span></div>
                        <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                            <Button
                                onClick={() => handleButtonClick("full-day")}
                                disabled={!isFullDayAllowed}
                                style={{
                                    borderRadius: '100px',
                                    backgroundColor: leaveFormDetails?.subType === "full-day" ? '#D6C8F5' : '#FFFFFF',
                                    color: '#636363',
                                    borderColor: leaveFormDetails?.subType === "full-day" ? '#D6C8F5' : '#CCCCCC',
                                    textTransform: 'none',
                                    fontSize: '14px',
                                    cursor: !isFullDayAllowed ? 'not-allowed' : 'pointer',
                                    opacity: !isFullDayAllowed ? 0.5 : 1
                                }}
                            >
                                Full day
                            </Button>
                            <Button
                                onClick={() => handleButtonClick("half-day")}
                                disabled={!isHalfDayAllowed}
                                style={{
                                    borderRadius: '100px',
                                    backgroundColor: leaveFormDetails?.subType === "half-day" ? '#D6C8F5' : '#FFFFFF',
                                    color: '#636363',
                                    borderColor: leaveFormDetails?.subType === "half-day" ? '#D6C8F5' : '#CCCCCC',
                                    textTransform: 'none',
                                    fontSize: '14px',
                                    cursor: !isHalfDayAllowed ? 'not-allowed' : 'pointer',
                                    opacity: !isHalfDayAllowed ? 0.5 : 1
                                }}
                            >
                                Half day
                            </Button>
                        </div>
                    </div>
                </TabPane>

                <TabPane tab={<div style={{ flex: 1, textAlign: 'center' }}>Special Leaves</div>}
                    key="special">
                    <div className='p-20'>
                        <AnimatedCustomSelect
                            keepOpenOnClick={true}
                            label={"Leave type"}
                            required={true}
                            options={specialLeaves?.map(leave => ({
                                label: leave.leaveType,
                                value: leave.leaveType
                            }))}
                            handleSelectChange={(value) => {
                                const selectedLeave = specialLeaves?.find(leave => leave.leaveType === value);
                                const selectedUserLeave = getSelectedUserLeave(selectedLeave?.leaveType);
                                const leaveStart = selectedUserLeave?.startDate && moment(selectedUserLeave.startDate).isValid()
                                    ? moment(selectedUserLeave.startDate).startOf('day')
                                    : null;
                                const leaveEnd = selectedUserLeave?.endDate && moment(selectedUserLeave.endDate).isValid()
                                    ? moment(selectedUserLeave.endDate).endOf('day')
                                    : null;
                                const bDays = getLeaveBackDays(selectedUserLeave);
                                const minStart = moment().subtract(bDays, 'days').startOf('day');

                                let nextStartDate = leaveFormDetails?.startDate;
                                let nextEndDate = leaveFormDetails?.endDate;
                                let nextDuration = leaveFormDetails?.duration;

                                if (nextStartDate) {
                                    const s = moment(nextStartDate).startOf('day');
                                    if (s.isBefore(minStart, 'day') || (leaveStart && s.isBefore(leaveStart, 'day')) || (leaveEnd && s.isAfter(leaveEnd, 'day'))) {
                                        nextStartDate = null;
                                        nextEndDate = null;
                                        nextDuration = '';
                                    }
                                }
                                if (nextEndDate && leaveEnd && moment(nextEndDate).isAfter(leaveEnd, 'day')) {
                                    nextEndDate = null;
                                    nextDuration = '';
                                }

                                setLeaveDetails({
                                    ...leaveFormDetails,
                                    leaveType: selectedLeave?.leaveType,
                                    subType: 'full-day',
                                    startDate: nextStartDate,
                                    endDate: nextEndDate,
                                    duration: nextDuration
                                });
                            }}
                            value={leaveFormDetails?.leaveType}
                            isSelected={leaveFormDetails?.leaveType ? true : false}
                        />
                    </div>
                </TabPane>
            </Tabs>



            <Row className='p-20' style={{ paddingTop: 0 }}>
                <Col span={12}>
                    <AnimatedDatePicker
                        inputId={"startdate"}
                        inputReadOnly={true}
                        label={"Start date"}
                        value={leaveFormDetails?.startDate}
                        allowClear={true}
                        disabled={!leaveFormDetails?.leaveType}
                        disabledDate={disabledStartDate}
                        handleDateChange={(value) => {
                            const isHalfDay = leaveFormDetails?.subType === 'half-day';
                            setLeaveDetails({
                                ...leaveFormDetails,
                                startDate: value || null,
                                endDate: (isHalfDay && value) ? value : null,
                                duration: ''
                            });
                        }}
                        isMandatory={true}
                    />
                </Col>
                <Col span={11} offset={1}>
                    <AnimatedDatePicker
                        inputId={"enddate"}
                        inputReadOnly={true}
                        label={"End date"}
                        value={leaveFormDetails?.endDate}
                        allowClear={true}
                        handleDateChange={(value) => {
                            setLeaveDetails({
                                ...leaveFormDetails,
                                endDate: value || null,
                                duration: value ? leaveFormDetails?.duration : ''
                            });
                        }}
                        disabled={!leaveFormDetails?.leaveType || !leaveFormDetails?.startDate || !allowSelectEndDate}
                        disabledDate={disabledEndDate}
                        isMandatory={true}
                    />

                </Col>
            </Row>

            <div className='p-20' style={{ paddingTop: 0 }}>
                {leaveFormDetails?.duration !== undefined && leaveFormDetails?.duration !== null && leaveFormDetails?.duration !== '' && (
                    <div style={{ backgroundColor: "#f3e8ff", borderRadius: "10px", padding: "10px" }}>
                        <div style={{ color: "#6b7280" }}>Duration</div>
                        <div style={{ color: "black", fontWeight: '500' }}>
                            {leaveFormDetails?.duration} {Number(leaveFormDetails?.duration) > 1 ? 'days' : 'day'}
                        </div>
                    </div>
                )}
            </div>
            <div className='p-20' style={{ paddingTop: 0 }}>
                <AnimatedTextField
                    inputId={"reason"}
                    label={"Reason"}
                    isMandatory={true}
                    style={{
                        border: "none",
                        borderBottom: "1px solid #E6E6E6",
                        display: "flex",
                        alignItems: "center"
                    }}
                    value={leaveFormDetails?.reason}
                    handleInputChange={e => setLeaveDetails({ ...leaveFormDetails, reason: e.target.value })}
                />
            </div>
            <div style={{ bottom: 0, position: 'absolute', width: '100%', display: 'flex', justifyContent: 'space-between', padding: '20px' }} className='r-c-c m-t-20' >
                <Button onClick={() => onClose(false)}>
                    CANCEL
                </Button>
                <Button
                    type="primary"
                    onClick={() => setConfirmVisible(true)}
                    loading={buttonLoader}
                    disabled={
                        !leaveFormDetails?.leaveType || leaveFormDetails?.leaveType === "" ||
                        !leaveFormDetails?.subType || leaveFormDetails?.subType === "" ||
                        !leaveFormDetails?.startDate || leaveFormDetails?.startDate === "" ||
                        !leaveFormDetails?.endDate || leaveFormDetails?.endDate === "" ||
                        !leaveFormDetails?.reason || leaveFormDetails?.reason?.trim() === ""
                    }
                >
                    SAVE
                </Button>
            </div>
        </Drawer>

        <ConfirmLeaveEdit
            visible={confirmVisible}
            onClose={() => setConfirmVisible(false)}
            onDelete={handleSave}
            deleteLoader={buttonLoader}
            message={
                isMark
                    ? "Are you sure you want to mark leaves for the selected dates?"
                    : "Are you sure you want to apply leaves for the selected dates?"
            }
        />
        </>
    );
};

const mapStateToProps = (state) => ({
    leaveTypes: state?.userManagementV3?.leaveTypes,
    leaveDetails_V3: state?.userManagementV3?.leaveDetails_V3,
    user: state?.session?.user || state?.globalState?.user,
    userRowDetails: state?.userManagementV3?.userRowDetails
});

const mapDispatchToProps = (dispatch) => ({
    requestLeaveOrAttendance: (params, callback, successCallback, pagecallback) => dispatch(requestLeaveOrAttendance(params, callback, successCallback, pagecallback)),
    calculateLeaveDays: (params, callback) => dispatch(calculateLeaveDays(params, callback))
})

export default connect(mapStateToProps, mapDispatchToProps)(MarkLeaveDrawer);
